import { client } from "../utils/netlify";
import { setCookie, getCookie, deleteCookie } from "cookies-next";
import { generalConstants } from "@/utils/constants";
import { getUserYotpoDetails } from "@/helpers/yotpoHelper";
import CryptoJS from 'crypto-js';
import store from "@/redux/store";
import { setUserCause } from "@/redux/actions/generalAction";
import { setCustomer } from "@/components/common/Nosto";
import { reportError } from "./errorHelper";

export const createAccount = async (request) => {
  try{
    let resp = await client("create-account", request)
    return resp;
  }catch (error) {
    reportError("Error in createAccount");
    reportError(error)
  }
  
};


export const createCustomerAsscoation = async (request) => {
  try{
    let resp = await client("customerEmail", request)
    return resp;
  }catch (error) {
    reportError("Error in createCustomerAsscoation");
    reportError(error)
  }
};

export const createCustomerShippingAsscoation = async (request) => {
  try{
    let resp = await client("shipAddress", request)
    return resp;
  }catch (error) {
    reportError("Error in createCustomerShippingAsscoation");
    reportError(error)
  }
};

export const checkoutCustomerDisassociate = async (request) => {
  try{
    let resp = await client("customerLogout", request)
    return resp;
  }catch (error) {
    reportError("Error in checkoutCustomerDisassociate");
    reportError(error)
  }};

export const forgotPassword = async (request) => {
  try{
    let resp = await client("forgot-password", request)
    return resp;
  }catch (error) {
    reportError("Error in forgotPassword");
    reportError(error)
  }
};

export const resetPassword = async (request) => {
  try{
    let resp = await client("reset-password", request)
    return resp;
  }catch (error) {
    reportError("Error in resetPassword");
    reportError(error)
  }
}

export const createAccessToken = async (request) => {
  try{
    let resp = await client("create-access-token", request)
    return resp;
  }catch (error) {
    reportError("Error in createAccessToken");
    reportError(error)
  }
};

export const validateAccessToken = async (request) => {
  try {
    if (typeof request !== "undefined") {
      const resp = await client("validate-access-token", request)
        if(resp) {
          /* Encrypting the user data and storing it into the session storage */
          sessionStorage.setItem('sAData', encryptString(JSON.stringify(resp.customer), request.token))
        }
      return resp;
    }
  } catch (error) {
    reportError("Error in validate access token")
    reportError(error)
  }
};
export const generateMultiPassURL = async (request) => {
  try{
    let resp = await client("multi-pass", request)
    return resp;
  }catch (error) {
    reportError("Error in generateMultiPassURL");
    reportError(error)
  }
};

export const customerLoginData = async (request) => {
  try{
    const resp = await client("customer-login-data", request)
    if(resp){
      sessionStorage.setItem('sAData', encryptString(JSON.stringify(resp.customer), request.token))
        // storing the cause info of customer into the redux state
        const customerCuaseValue= resp?.customer?.tags[0]?.split(":")[1]
        store.dispatch(setUserCause(customerCuaseValue));
    }
    return resp;
  }catch(error){
    reportError("Error in customerLoginData")
    reportError(error)
  }
};

export const renewAccessToken = async (request) => {
  try{
    let resp = await client("renew-access-token", request)
    return resp;
  }catch (error) {
    reportError("Error in renewAccessToken");
    reportError(error)
  }
};

export const deleteAccessToken = async (request) => {
  try{
    let resp = await client("delete-access-token", request)
    return resp;
  }catch (error) {
    reportError("Error in deleteAccessToken");
    reportError(error)
  }
};

export const createUserLogin = async (response, userData, expiry) => {
  if (expiry) {
    setCookie("userdataToken", JSON.stringify(response.customerAccessToken), {
      expires: new Date(response.customerAccessToken.expiresAt),
    });
  } else {
    // let now = new Date();
    // now.setTime(now.getTime() + 1 * 3600 * 1000);
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    setCookie("userdataToken", JSON.stringify(response.customerAccessToken), {
      expires: tomorrow,
    });
  }
};

export const checkUserLogin = async (token) => {
  if (token) {
    let ret = await validateAccessToken({ token: token });
    if (ret && ret.customer && ret.customer.id) {
      let yotpoDetails = await getUserYotpoDetails({ email: ret.customer.email });
      return {
        userLoggedIn: true,
        userData: ret.customer,
        yotpoDetails: yotpoDetails
      };
    } else {
      // setCookie("userdataToken", null);
    }
  }
  return {
    userLoggedIn: false,
    userData: {},
  };
};

/*
* This function gets the user cause from the tag and checks if its active.
* If not actie it returns the default cause
*/
export const extractUserCauseFromTags = async (tags) => {
  var cause_list = JSON.parse(localStorage.getItem('cause_list'))
  
  if (tags) {
    let cause = tags.filter((tag) => {
      return tag.includes('cause:')
    }).map((tag) => {
      let str = tag.split(':')
      return str[1];
    })
    
    let userCause = cause_list.find(
      (causeL) => (causeL.short_code === cause[0] && causeL.active == 1)
    );

    if(typeof userCause == 'undefined'){
      let default_cause = cause_list.find(
        (cause) => (cause.active == 1 && cause.site_default == 1)
      );
      cause[0] = default_cause.short_code;
    }

    return (cause.length > 0) ? cause : [];
  }
  return [];
};

export const slideUp = (target, duration = 500) => {
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
    //alert("!");
  }, duration);
};

export const slideDown = (target, duration = 500) => {
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";

  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  target.style.removeProperty("padding-top");
  target.style.removeProperty("padding-bottom");
  target.style.removeProperty("margin-top");
  target.style.removeProperty("margin-bottom");
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};

export const slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === "none") {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
};
export const iOS = () => {
  if (typeof document !== "undefined") {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }
};
export const bodyOverflow = (value = true) => {
  if (typeof document !== "undefined") {
    let iPhone = false;
    if (iOS()) {
      iPhone = true;
    }

    if (value) {
      if (iPhone) {
        window.lastYScroll = window.pageYOffset;
        window.lastXScroll = window.pageXOffset;
        document.querySelector("body").classList.add("ios-device");
        document.querySelector("html").classList.add("ios-device");
      }
      document.querySelector("body").classList.add("overflow-hidden");
      var isAccountSigninPopup = document.getElementsByClassName('account-drawer-open');
      if (isAccountSigninPopup.length <= 0 ) {
        document.querySelector("html").classList.add("overflow-hidden");    
      } else {
        document.querySelector("html").classList.add("overflow-hidden-ipmb");
      }
    } else {
      document.querySelector("body").classList.remove("overflow-hidden");
      document.querySelector("html").classList.remove("overflow-hidden");
      document.querySelector("html").classList.remove("overflow-hidden-ipmb");
      if (iPhone) {
        document.querySelector("body").classList.remove("ios-device");
        document.querySelector("html").classList.remove("ios-device");
        //window.scrollTo(window.lastXScroll, window.lastYScroll);
      }
    }
  }
};

export const handleize = (str) => {
  if (!str) {
    return;
  }
  str = str.toLowerCase();
  let toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
  for (let i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], "");
  }
  str = str.replace(/\W+/g, "-");
  if (str.charAt(str.length - 1) === "-") {
    str = str.replace(/-+\z/, "");
  }
  if (str.charAt(0) === "-") {
    str = str.replace(/\A-+/, "");
  }
  return str;
};
export const imgURL = (src, size) => {
  try {
    if (src) {
      return src
        .replace(
          /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
          "."
        )
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
          return "_" + size + match;
        });
    }
    return null;
  } catch (e) {
    reportError("Error in imgURL")
    reportError(e.stack);
    return src;
  }
};
export const srcsetMaker = (src, retinaImage = false) => {
  let srcset = "";
  let srcsetArray = [370, 640, 750, 828, 960, 1080, 1200, 1920, 2048, 3840];
  srcsetArray = srcsetArray.map((srcNo) => {
    if (retinaImage) {
      srcset = `${srcset} ${imgURL(src, `${srcNo * 2}x`)} ${srcNo}w,`;
    }
    else {
      srcset = `${srcset} ${imgURL(src, `${srcNo / 2}x`)} ${srcNo}w,`;
    }
  });
  return srcset;
}

export const makeId = (length) => {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
};

export function mobMenuHeigh() {


  const mainMenuListMobile = document.querySelector('.main_menu_list_mobile')
  if (mainMenuListMobile) {
    const mobBottomMenus = document.querySelector('.mob_bottom_menus_mobile')
    setTimeout(() => {

      mainMenuListMobile.style.setProperty('--mob_menu_height', `${mobBottomMenus?.offsetHeight}px`)
    }, 500)
  }
}


export const activeCustomerByUrl = async (request) => {
  try{
    let resp = await client("activateCustomer", request)
    return resp;
  }catch (error) {
    reportError("Error in activeCustomerByUrl");
    reportError(error)
  }
};

export const createAccountMigrate = async (request) => {
  try{
    let resp = await client("create-account-migrate", request)
    return resp;
  }catch (error) {
    reportError("Error in createAccountMigrate");
    reportError(error)
  }
};

export const getCustomerDataByEmail = async (request) => {
  try{
    let resp = await client("get-customer", request)
    return resp;
  }catch (error) {
    reportError("Error in getCustomerDataByEmail");
    reportError(error)
  }
};

export const getCustomerDataById = async (request) => {
  try{
    let resp = await client("get-customer-by-id", request)
    return resp;
  }catch (error) {
    reportError("Error in getCustomerDataById");
    reportError(error)
  }
};

//returns firstName, lastName, email, state, tags, createdAt
export const getCustomerDetailsById = async (request) => {
  try{
    let resp = await client("get-customer-details-by-id", request)
    return resp;
  }catch (error) {
    reportError("Error in getCustomerDetailsById");
    reportError(error)
  }
};

export const checkMigratedCustomer = async (email) => {
  const resp = await getCustomerDataByEmail({
    email: email
  });

  if (resp && resp.email && generalConstants.migrated_customer_flag.includes(resp.state)) {
    return resp.state;
  }

  return false;
};

export const checkCustomerExist = async (email) => {
  const resp = await getCustomerDataByEmail({
    email: email
  });
  if (resp && resp.email) {
    let cusId;
    if (resp.id) {
      cusId = resp.id.split('/');
      cusId = cusId[cusId.length - 1];
    }
    resp.customerId = cusId;
    return resp;
  }

  return false;
};

export const updateUserCheckoutID = async (request) => {
  try{
    let resp = await client("update-user-checkout-id", request)
    return resp;
  }catch (error) {
    reportError("Error in updateUserCheckoutID");
    reportError(error)
  }
};

export const updateUserWishlistID = async (request) => {
  try{
    let resp = await client("update-user-wishlist-id", request)
    return resp;
  }catch (error) {
    reportError("Error in updateUserWishlistID");
    reportError(error)
  }
};

export const updateUserCheckoutIDByEmail = async (request) => {
  try{
    let resp = {};
    const respUser = await getCustomerDataByEmail({
      email: request?.email
    });
    if (respUser?.id) {
      request.id = respUser.id;
      resp = await client("update-user-checkout-id", request)
    }
    return resp;
  }catch (error) {
    reportError("Error in updateUserCheckoutIDByEmail");
    reportError(error)
  }
};

export const handleSignOut = async (customPath) => {
  deleteCookie("userdataToken");
  deleteCookie('klaviyo_profile_identified')
  sessionStorage.removeItem("sAData");
  deleteCookie(generalConstants.user_discount_tag);
  //OS-4874 as we are not manually associating the customer using mutation shoudl not be needed
  // let checkoutId = getCookie("new_checkoutId");
  /* Disassociate user from checkout */
  // if (typeof checkoutId !== "undefined" && checkoutId != "") {
  //   await checkoutCustomerDisassociate(checkoutId);
  // }
  deleteCookie("new_checkoutId");
  if (customPath) {
    window.location.href = customPath;
    return;
  }
  setCustomer(null);
  window.location.reload();
};

export const getPasswordFromCookie = async () => {
  let encPassword = getCookie(process.env.USER_PASSWORD_COOKIE);
  let password = '';
  if (encPassword) {
    var bytes = CryptoJS.AES.decrypt(encPassword, process.env.SECRET_KEY_CRYPTO);
    let tempPassword = bytes.toString(CryptoJS.enc.Utf8);
    password = tempPassword.split("-")[1];
    password = password ? password.trim() : '';
  }
  return password;
};

export const encryptString = (plaintext, key) => {
  /* To encrypt a sting with the given key  */
  let encrypted = "";
  for (let i = 0; i < plaintext.length; i++) {
    const charCode = plaintext.charCodeAt(i) ^ key.charCodeAt(i % key.length);
    encrypted += String.fromCharCode(charCode);
  }
  return encrypted;
};
export function decryptString(encrypted, key) {
  /* To decrypt a sting with the given key if the key is correct  */
  let decrypted = "";
  for (let i = 0; i < encrypted.length; i++) {
    const charCode = encrypted.charCodeAt(i) ^ key.charCodeAt(i % key.length);
    decrypted += String.fromCharCode(charCode);
  }
  return decrypted;
}

// function that gets the query params and generates the array of objects from it
export const queryParamsToArray = (queryString) => {
  const params = new URLSearchParams(queryString);
  const paramArray = Array.from(params.entries());
  const paramObjectsArray = paramArray?.map(([key, value]) => ({ [key]: value }));
  return paramObjectsArray;
}

// function that gets the params array and generate the query string from it
export const arrayToQueryParams = (paramObjectsArray) => {
  const params = new URLSearchParams();
  paramObjectsArray?.forEach(paramObj => {
    const key = Object.keys(paramObj)[0];
    const value = paramObj[key];
    params.append(key, value);
  });
  return params.toString();
}

export const performKlaviyoMerge = async (email,external_id) => {
  localStorage.setItem('klaviyo_external_profile_id','');
  let destProfile = await getKlaviyoProfileAPI(
    {
      "email": email,
      "field":"email"
    })
  let mergeProfile = await getKlaviyoProfileAPI(
    {
      "email": external_id,
      "field":"external_id"
    })
  if(destProfile && mergeProfile && destProfile != mergeProfile) {
    await updateKlaviyoExternalIdAPI({ "destinationId" : mergeProfile,"externalId":"" });
    await updateKlaviyoExternalIdAPI({ "destinationId" : destProfile,"externalId":external_id });
    await mergeKlaviyoProfileAPI({
      "mergeId":mergeProfile,
      "destinationId":destProfile
    });
    if(typeof klaviyo !== 'undefined' && klaviyo){
      klaviyo.identify({'id' : destProfile});
      setCookie('klaviyo_profile_identified', "true")
    }  
  }
};

export const getKlaviyoProfileAPI = async (request) => {
  try{
    let resp = await client("get-klaviyo-profile", request)
    return resp;
  }catch (error) {
    reportError("Error in getKlaviyoProfileAPI");
    reportError(error)
  }
};

export const updateKlaviyoExternalIdAPI = async (request) => {
  try{
    let resp = await client("update-klaviyo-profile", request)
    return resp;
  }catch (error) {
    reportError("Error in updateKlaviyoExternalIdAPI");
    reportError(error)
  }
};

export const mergeKlaviyoProfileAPI = async (request) => {
  try{
    let resp = await client("merge-klaviyo-profile", request)
    return resp;
  }catch (error) {
    reportError("Error in mergeKlaviyoProfileAPI");
    reportError(error)
  }
};